import React, { useState } from 'react';
import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';

import PrimaryButton from '../../components/PrimaryButton';

const onClick = (history, setLoading) => () => {
    setLoading(true);

    const sendConfirmationMail = firebase
        .functions()
        .httpsCallable('sendConfirmationMail');

    sendConfirmationMail({
        recipient: firebase.auth().currentUser.email,
        displayName: firebase.auth().currentUser.displayName,
    }).then(() => {
        history.push('/dashboard/confirmation?success=true');
        setLoading(false);
    });
}

function Signature({ history }) {
    const [loading, setLoading] = useState(false);

    return (
        <div className='modal'>
            <div className='modal__content'>
                <div className='modal__title'>
                    <h2>Vertragsunterzeichnung</h2>
                </div>
                <div className='modal__body'>
                    <p>Ihre Identität wurde erfolgreich verifiziert, mit dem Klick auf "unterzeichnen" können Sie Ihren Vertrag jetzt abschließen und erhalten im Anschluss die Kreditsumme sofort auf Ihr Girokonto gutgeschrieben.</p>
                </div>
                <div className='credit'>
                    <ul className='credit__additional'>
                        <li>Laufzeit: 84 Monate</li>
                        <li>Freie Verwendung</li>
                        <li>Sofortauszahlung</li>
                    </ul>
                    <dl className='credit__sum'>
                        <dt>Kredithöhe:</dt>
                        <dd>20.000€</dd>
                        <dt>Kreditzins:</dt>
                        <dd>3,39% <small>p.a. eff.</small></dd>
                        <dt>mtl. Gesamtrate:</dt>
                        <dd>268,00€</dd>
                    </dl>
                </div>
                <div className='modal__footer'>
                    <PrimaryButton
                        loading={loading}
                        loadingInside={loading}
                        title='Vertrag jetzt verbindlich unterzeichnen'
                        onClick={onClick(history, setLoading)}
                    />
                </div>
            </div>
        </div>
    )
}

export default Signature;
